export function applyChosen(element) {
  element.on('chosen:ready', function (evt, params) {
    let placeholder = $(this).data('label');
    let container = params.chosen.container;

    container.prepend('<span class=\'animate-label\'>' + placeholder + '</span>')
      .closest('.mobile-animate-wrapp')
      .removeClass('mobile-animate-wrapp')
      .find('label')
      .remove();

    if (this.value.length || $(this.options[this.selectedIndex]).text() === I18n.t('js.all')) { // eslint-disable-line no-undef
      container.addClass('filled')
    }
  });

  element.chosen({
    width: '100%',
    include_group_label_in_selected: true,
    placeholder_text_single: ' ',
    placeholder_text_multiple: ' ',
    hide_results_on_select: false
  });

  element.on('change', function (evt) {
    if (this.value.length || $(this.options[this.selectedIndex]).text() === I18n.t('js.all')) { // eslint-disable-line no-undef
      $(evt.target).next().addClass('filled');
    } else {
      $(evt.target).next().removeClass('filled');
    }
  });

  element.on('chosen:showing_dropdown', function (evt, params) {
    params.chosen.container.addClass('filled');
  });

  element.on('chosen:hiding_dropdown', function (evt, params) {
    if (!this.value.length && $(this.options[this.selectedIndex]).text() !== I18n.t('js.all')) { // eslint-disable-line no-undef
      params.chosen.container.removeClass('filled')
    }
  });

  element.on('chosen:updated', function () {
    if (!this.value.length) {
      $(this).next().removeClass('filled');
    } else {
      $(this).parent().find('.chosen-container').addClass('filled');
    }
  });
}

window.applyChosen = applyChosen;

export function animateLabel(elem) {
  elem ? elem.classList.add('filled') : null;
}

export function reverseAnimateLabel(elem) {
  elem ? elem.classList.remove('filled') : null;
}

export function resetSelect(selectToReset) {
  var options = '<option value=""></option>';
  selectToReset.html(options);
  selectToReset.attr('disabled', true);
  selectToReset.trigger('chosen:updated');
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/selects_helper.js